import { createContext, useCallback, useContext, useState } from 'react';

import _noop from '@julofinance/web-helpers/dist/fn/noop';

import { useDisclosure } from 'hooks/use-disclosure';

import type {
  SnackbarContextProps,
  SnackbarOptions,
  SnackbarProviderProps,
} from './types';
import Snackbar from './Snackbar';

const SnackbarContext = createContext<SnackbarContextProps>({
  onClose: _noop,
  onOpen: _noop,
});

const SnackbarProvider = (props: SnackbarProviderProps) => {
  const { children } = props;

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [snackbarOptions, setSnackbarOptions] = useState<SnackbarOptions>();

  const handleOpen = useCallback(
    (snackbarOptions?: SnackbarOptions) => {
      onOpen();
      setSnackbarOptions(snackbarOptions);
    },
    [onOpen],
  );

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <SnackbarContext.Provider
      value={{ onOpen: handleOpen, onClose: handleClose }}
    >
      {children}
      <Snackbar open={isOpen} onClose={handleClose} {...snackbarOptions} />
    </SnackbarContext.Provider>
  );
};

const useSnackbar = () => {
  const context = useContext(SnackbarContext);

  if (!context)
    throw new Error('useSnackbar muse be used within SnackbarProvider');

  return context;
};

export { SnackbarProvider, useSnackbar };
